import { PaginationQueryObject, QueryConfig } from "./Queries";

export const applicationsListQuery = (
  filter: any,
  pagination: PaginationQueryObject
): QueryConfig => {
  const query = `query getApplicationsList($filter: ApplicationFilter, $pagination: PaginationInput) {
            applications(filter: $filter, paginationInput: $pagination){
                items { id, name },
                pageInfo { pageSize, pageNumber, totalElements, totalPages, hasNext, hasPrevious }
            }
        }`;
  return {
    query: query,
    variables: {
      filter: filter,
      pagination: pagination,
    },
  };
};

export type GrantCustomerApplicationsInput = {
  customerId: string;
  applicationIds: string[];
  applications?: [{ id: string; url: string | null }];
};

export const grantCustomerApplicationAssignmentsMutation = (
  customerApplicationsInput: GrantCustomerApplicationsInput
): QueryConfig => {
  const query = `mutation grantCustomerApplications($customerApplicationAssignments: GrantCustomerApplicationsInput!) {
            grantCustomerApplications(input: $customerApplicationAssignments)
        }`;
  return {
    query: query,
    variables: {
      customerApplicationAssignments: customerApplicationsInput,
    },
  };
};

export type RemoveCustomerApplicationsInput = {
  customerId: string;
  applicationIds: string[];
};

export const removeCustomerApplicationAssignmentsMutation = (
  customerApplicationsInput: RemoveCustomerApplicationsInput
): QueryConfig => {
  const query = `mutation handleRemoveCustomerApplications($customerApplicationAssignments: RemoveCustomerApplicationsInput!) {
            removeCustomerApplications(input: $customerApplicationAssignments)
        }`;
  return {
    query: query,
    variables: {
      customerApplicationAssignments: customerApplicationsInput,
    },
  };
};

export type UpdateCustomerApplicationUrlInput = {
  applicationId: string;
  customerId: string;
  applicationUrl?: string;
};

export const editCustomerApplicationMutation = (
  input: UpdateCustomerApplicationUrlInput
): QueryConfig => {
  const query = `mutation updateCustomerApplicationUrl($input: UpdateCustomerApplicationUrlInput!) {
    updateCustomerApplicationUrl(input: $input) { applicationURL }
  }`;

  return {
    query: query,
    variables: {
      input: input,
    },
  };
};
